import { Spinner } from '@Common/Spinner';
import { Elements } from '@stripe/react-stripe-js';
import { stripeOptions } from 'appConstants';
import { SetStateType } from 'commonTypes';
import { useConfigureStripe } from 'store/subscription/actions';

import { BillingForm } from './BillingForm';

interface BillingFreeTrialStepProps {
  setStep: SetStateType<number>;
}

export const BillingFreeTrialStep = ({ setStep }: BillingFreeTrialStepProps) => {
  const { data: stripePromise, isPending } = useConfigureStripe();

  if (isPending || !stripePromise) {
    return <Spinner />;
  }

  return (
    <Elements stripe={stripePromise} options={stripeOptions}>
      <BillingForm onSubmit={() => setStep((prev) => prev + 1)} />
    </Elements>
  );
};
